import React from 'react';
import './Arbitro.css';

export default function Clube(props) {
	if (!props.arbitro?.id) {
		return null;
	}
	return (
		<div key={props.arbitro.id} className={"arbitro " + (props.arbitro.fifa > 0 ? "fifa" : "")}>
			<span className="nome">{props.arbitro.name}</span>
		</div>
	);
}
